/**
 * PrepMasterListPrint — Page dédiée à l'aperçu et à l'impression A4
 * de la Liste maîtresse "Préparation jour J".
 *
 * Route : /admin/gestion/liste-preparation/print
 *
 * - Ne contient AUCUN menu ni chrome admin.
 * - Auto-ouvre la boîte de dialogue d'impression après chargement.
 * - Compatible AirPrint iOS/iPadOS + impression bureau.
 */

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { rgApi } from "@/lib/rgApi";
import "./prep-master-list.css";

export default function PrepMasterListPrint() {
  const [sections, setSections] = useState(null);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        const d = await rgApi.getPrepMasterList();
        setSections(d.sections || []);
      } catch (e) {
        setError(String(e.message || e));
      }
    })();
  }, []);

  useEffect(() => {
    // Auto-print une fois les données chargées (pas d'action utilisateur nécessaire)
    if (sections && !error) {
      const t = setTimeout(() => window.print(), 500);
      return () => clearTimeout(t);
    }
  }, [sections, error]);

  if (error) {
    return (
      <div className="prep-print-root" data-testid="rg-prep-print-page-error">
        <p style={{ color: "#8B2530" }}>Erreur de chargement : {error}</p>
      </div>
    );
  }
  if (!sections) {
    return (
      <div className="prep-print-root" data-testid="rg-prep-print-page-loading">
        <p>Chargement…</p>
      </div>
    );
  }

  return (
    <div className="prep-print-root" data-testid="rg-prep-print-page">
      <div className="prep-print-toolbar">
        <button type="button" className="rg-btn ghost" onClick={() => navigate(-1)} data-testid="rg-prep-print-back">
          ← Retour
        </button>
        <button type="button" className="rg-btn primary" onClick={() => window.print()} data-testid="rg-prep-print-now">
          🖨️ Imprimer
        </button>
      </div>
      <div className="prep-print-doc">
        <h1>Liste préparation jour J</h1>
        <p className="prep-print-sub">Curieux Refuge · Check-list de préparation</p>
        {sections.map((s) => (
          <section key={s.id} data-testid={`rg-prep-print-sec-${s.id}`}>
            <h2>{s.title}</h2>
            {(s.groups || []).map((g, gi) => (
              <div key={gi} className="group">
                {g.title && <h3>{g.title}</h3>}
                <ul>
                  {(g.items || []).filter((it) => (it || "").trim()).map((it, ii) => (
                    <li key={ii}><span className="check-box" /> {it}</li>
                  ))}
                </ul>
              </div>
            ))}
          </section>
        ))}
      </div>
    </div>
  );
}
